import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Input, ListGroup, ListGroupItem } from "reactstrap";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { colors } from '../../config/constants';
import ShowIf from '../ShowIf/ShowIf';

const InputSearch = (props) => {
  const { onChange, value, clearValue, onEnter, withItems = false, items = [], goToSearch, onBlurEvent } = props;

  const onEnterKey = ({ key }) => {
    if (onEnter) {
      if (key === 'Enter') {
        onEnter(value);
      }
    }
  };
  return (
    <Fragment>
      <ShowIf show={!value}>
        <IoMdSearch className='search-placeholder' color={colors.lightBlueText} />
      </ShowIf>
      <ShowIf show={value}>
        <IoMdClose onClick={clearValue} className='search-placeholder clickable' color={colors.lightBlueText} />
      </ShowIf>
      <div>
        <Input className='search-input' type='text' placeholder='Search...'
          onChange={onChange} onKeyDown={onEnterKey}
          value={value} onBlur={onBlurEvent}
        />

        <ShowIf show={withItems && items.length > 0}>
          <ListGroup style={{
            position: 'absolute',
            width: '98%',
            zIndex: 1,
            height : '300px',
            overflow : 'auto'
          }}>
            {
              items.map(_i => {
                return <ListGroupItem key={`keyIn${_i.genericGroupId}`} onClick={() => goToSearch(_i.comparisonViewId, _i.genericName)} className="justify-content-between clickable">
                  <span className="text-main text-capitalize">{_i.comparisonViewName} </span>: {_i.genericName}
                </ListGroupItem>
              })
            }
          </ListGroup>
        </ShowIf>

      </div>

    </Fragment >
  );
};

InputSearch.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
  clearValue: PropTypes.func.isRequired,
  onEnter: PropTypes.func
}

export default InputSearch;